
import { defineComponent, ref, reactive, toRefs, onMounted, computed, nextTick, watchEffect, watch } from 'vue'

import { DoubleRightOutlined, DoubleLeftOutlined } from '@ant-design/icons-vue'
import router from '@/router/index'
import { useRoute } from 'vue-router'
import Navatop from '@/components/navtop.vue'
import f10Api from '@/api/f10Api'
import Table from '@/components/table.vue'
import Nodata from '@/components/page/nodata.vue'
// import func from "vue-temp/vue-editor-bridge";
const myColumns: any = {
  ybqy: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time'
      // width: "100px",
      // fixed: "left",
    },
    {
      title: '营业总收入',
      dataIndex: 'TotalOperatingRevenue',
      key: 'TotalOperatingRevenue'
    },
    {
      title: '营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue',
      indentStep: 1
    },
    {
      title: '营业总成本',
      dataIndex: 'TotalOperatingCost',
      key: 'TotalOperatingCost'
    },
    {
      title: '营业成本',
      dataIndex: 'OperatingCost',
      key: 'OperatingCost',
      indentStep: 1
    },
    {
      title: '研发费用',
      dataIndex: 'RAndD',
      key: 'RAndD',
      indentStep: 1
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1
    },
    {
      title: '销售费用',
      dataIndex: 'OperatingExpense',
      key: 'OperatingExpense',
      indentStep: 1
    },
    {
      title: '管理费用',
      dataIndex: 'AdministrationExpense',
      key: 'AdministrationExpense',
      indentStep: 1
    },
    {
      title: '财务费用',
      dataIndex: 'FinancialExpense',
      key: 'FinancialExpense',
      indentStep: 1
    },
    {
      title: '其中:利息费用',
      dataIndex: 'InterestFinExp',
      key: 'InterestFinExp',
      indentStep: 1
    },
    {
      title: '利息收入',
      dataIndex: 'InterestIncomeFin',
      key: 'InterestIncomeFin',
      indentStep: 2
    },
    {
      title: '其他经营收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '加:公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1
    },
    {
      title: '投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 2
    },
    {
      title: '其中:对联营企业和合营企业的投资收益',
      dataIndex: 'InvestIncomeAssociates',
      key: 'InvestIncomeAssociates',
      indentStep: 1
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1
    },
    {
      title: '资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1
    },
    {
      title: '营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit'
    },
    {
      title: ' 加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1
    },
    {
      title: '利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit'
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit'
    },
    {
      title: '（一）按经营持续性分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '持续经营净利润',
      dataIndex: 'OperSustNetP',
      key: 'OperSustNetP',
      indentStep: 1
    },
    {
      title: '（二）按所有权归属分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '归属于母公司股东的净利润',
      dataIndex: 'NPParentCompanyOwners',
      key: 'NPParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '少数股东损益',
      dataIndex: 'MinorityProfit',
      key: 'MinorityProfit',
      indentStep: 1
    },
    {
      title: '扣除非经常性损益后的净利润',
      dataIndex: 'NetProfitCut',
      key: 'NetProfitCut',
      indentStep: 1
    },
    {
      title: '每股收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '基本每股收益',
      dataIndex: 'BasicEPS',
      key: 'BasicEPS',
      indentStep: 1
    },
    {
      title: '稀释每股收益',
      dataIndex: 'DilutedEPS',
      key: 'DilutedEPS',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome'
    },
    {
      title: '归属于母公司股东的其他综合收益',
      dataIndex: 'OCIParentCompanyOwners',
      key: 'OCIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的其他综合收益',
      dataIndex: 'OCIMinorityOwners',
      key: 'OCIMinorityOwners',
      indentStep: 1
    },
    {
      title: '综合收益总额',
      dataIndex: 'TotalCompositeIncome',
      key: 'TotalCompositeIncome'
    },
    {
      title: '归属于母公司股东的综合收益总额',
      dataIndex: 'CIParentCompanyOwners',
      key: 'CIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的综合收益总额',
      dataIndex: 'CIMinorityOwners',
      key: 'CIMinorityOwners',
      indentStep: 1
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  bank: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue'
      // width: "100px",
      // fixed: "left",
    },
    {
      title: '利息净收入',
      dataIndex: 'NetInterestIncome',
      key: 'NetInterestIncome',
      indentStep: 1
    },
    {
      title: '其中:利息收入',
      dataIndex: 'InterestIncome',
      key: 'InterestIncome',
      indentStep: 1
    },
    {
      title: '利息支出',
      dataIndex: 'InterestExpense',
      key: 'InterestExpense',
      indentStep: 2
    },
    {
      title: '手续费及佣金净收入',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1
    },
    {
      title: '其中:手续费及佣金收入',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1
    },
    {
      title: '手续费及佣金支出',
      dataIndex: 'CommissionExpense',
      key: 'CommissionExpense',
      indentStep: 2
    },
    {
      title: '加:投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1
    },
    {
      title: '其中:对联营企业和合营企业的投资收益/（损失）',
      dataIndex: 'InvestIncomeAssociates',
      key: 'InvestIncomeAssociates',
      indentStep: 2
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1
    },
    {
      title: '汇兑收益',
      dataIndex: 'ExchangeIncome',
      key: 'ExchangeIncome',
      indentStep: 1
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1
    },
    {
      title: '营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout'
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1
    },
    {
      title: '业务及管理费',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1
    },
    {
      title: '资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1
    },
    {
      title: '其他业务成本',
      dataIndex: 'OtherOperatingCost',
      key: 'OtherOperatingCost',
      indentStep: 1
    },
    {
      title: '营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit'
    },
    {
      title: '加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1
    },
    {
      title: '利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit'
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit'
    },
    {
      title: '(一)按经营持续性分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '持续经营净利润',
      dataIndex: 'OperSustNetP',
      key: 'OperSustNetP',
      indentStep: 1
    },
    {
      title: '(二)按所有权归属分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '其中:归属于母公司股东的净利润',
      dataIndex: 'NPParentCompanyOwners',
      key: 'NPParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '少数股东损益',
      dataIndex: 'MinorityProfit',
      key: 'MinorityProfit',
      indentStep: 1
    },
    {
      title: '扣除非经常性损益后的净利润',
      dataIndex: 'NetProfitCut',
      key: 'NetProfitCut',
      indentStep: 1
    },
    {
      title: '每股收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '基本每股收益',
      dataIndex: 'BasicEPS',
      key: 'BasicEPS',
      indentStep: 1
    },
    {
      title: '稀释每股收益',
      dataIndex: 'DilutedEPS',
      key: 'DilutedEPS',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome'
    },
    {
      title: '归属于母公司股东的其他综合收益',
      dataIndex: 'OCIParentCompanyOwners',
      key: 'OCIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的其他综合收益',
      dataIndex: 'OCIMinorityOwners',
      key: 'OCIMinorityOwners',
      indentStep: 1
    },
    {
      title: '综合收益总额',
      dataIndex: 'TotalCompositeIncome',
      key: 'TotalCompositeIncome'
    },
    {
      title: '归属于母公司股东的综合收益总额',
      dataIndex: 'CIParentCompanyOwners',
      key: 'CIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的综合收益总额',
      dataIndex: 'CIMinorityOwners',
      key: 'CIMinorityOwners',
      indentStep: 1
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  bond: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue'
    },
    {
      title: '手续费及佣金净收入',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1
    },
    {
      title: '其中: 代理买卖证券业务净收入',
      dataIndex: 'NetProxySecuIncome',
      key: 'NetProxySecuIncome',
      indentStep: 1
    },
    {
      title: '证券承销业务净收入',
      dataIndex: 'NetSubIssueSecuIncome',
      key: 'NetSubIssueSecuIncome',
      indentStep: 1
    },
    {
      title: '受托客户资产管理业务净收入',
      dataIndex: 'NetTrustIncome',
      key: 'NetTrustIncome',
      indentStep: 1
    },
    {
      title: '利息净收入',
      dataIndex: 'NetInterestIncome',
      key: 'NetInterestIncome',
      indentStep: 1
    },
    {
      title: '加:投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1
    },
    {
      title: '其中:对联营企业和合营企业的投资收益/（损失）',
      dataIndex: 'InvestIncomeAssociates',
      key: 'InvestIncomeAssociates',
      indentStep: 1
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1
    },
    {
      title: '汇兑收益',
      dataIndex: 'ExchangeIncome ',
      key: 'ExchangeIncome',
      indentStep: 1
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1
    },
    {
      title: '营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout'
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1
    },
    {
      title: ' 业务及管理费',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1
    },
    {
      title: '营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit'
    },
    {
      title: '加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1
    },
    {
      title: '利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit'
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit'
    },
    {
      title: '(一)按经营持续性分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '持续经营净利润',
      dataIndex: 'OperSustNetP',
      key: 'OperSustNetP',
      indentStep: 1
    },
    {
      title: '(二)按所有权归属分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '其中:归属于母公司股东的净利润',
      dataIndex: 'NPParentCompanyOwners',
      key: 'NPParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '少数股东损益',
      dataIndex: 'MinorityProfit',
      key: 'MinorityProfit',
      indentStep: 1
    },
    {
      title: '扣除非经常性损益后的净利润',
      dataIndex: 'NetProfitCut',
      key: 'NetProfitCut',
      indentStep: 1
    },
    {
      title: '每股收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '基本每股收益',
      dataIndex: 'BasicEPS',
      key: 'BasicEPS',
      indentStep: 1
    },
    {
      title: '稀释每股收益',
      dataIndex: 'DilutedEPS',
      key: 'DilutedEPS',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome'
    },
    {
      title: '归属于母公司股东的其他综合收益',
      dataIndex: 'OCIParentCompanyOwners',
      key: 'OCIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的其他综合收益',
      dataIndex: 'OCIMinorityOwners',
      key: 'OCIMinorityOwners',
      indentStep: 1
    },
    {
      title: '综合收益总额',
      dataIndex: 'TotalCompositeIncome',
      key: 'TotalCompositeIncome'
    },
    {
      title: '归属于母公司股东的综合收益总额',
      dataIndex: 'CIParentCompanyOwners',
      key: 'CIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的综合收益总额',
      dataIndex: 'CIMinorityOwners',
      key: 'CIMinorityOwners',
      indentStep: 1
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  insurance: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue'
    },
    {
      title: '已赚保费',
      dataIndex: 'PremiumsEarned',
      key: 'PremiumsEarned',
      indentStep: 1
    },
    {
      title: '其中: 保险业务收入',
      dataIndex: 'PremiumsIncome',
      key: 'PremiumsIncome',
      indentStep: 1
    },
    {
      title: '保险业务收入-分保费收入',
      dataIndex: 'ReinsuranceIncome',
      key: 'ReinsuranceIncome',
      indentStep: 2
    },
    {
      title: '分出保费',
      dataIndex: 'Reinsurance',
      key: 'Reinsurance',
      indentStep: 2
    },
    {
      title: '提取未到期责任准备金',
      dataIndex: 'UnearnedPremiumReserve',
      key: 'UnearnedPremiumReserve',
      indentStep: 2
    },
    {
      title: '加:投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1
    },
    {
      title: '其中:对联营企业和合营企业的投资收益/（损失）',
      dataIndex: 'InvestIncomeAssociates',
      key: 'InvestIncomeAssociates',
      indentStep: 1
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1
    },
    {
      title: '其中:可供出售金融资产公允价值变动损益',
      dataIndex: 'OCIFairValue',
      key: 'OCIFairValue',
      indentStep: 1
    },
    {
      title: '汇兑收益',
      dataIndex: 'ExchangeIncome',
      key: 'ExchangeIncome',
      indentStep: 1
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1
    },
    {
      title: '营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout'
    },
    {
      title: '退保金',
      dataIndex: 'RefundedPremiums',
      key: 'RefundedPremiums',
      indentStep: 1
    },
    {
      title: '赔付支出',
      dataIndex: 'CompensationExpense',
      key: 'CompensationExpense',
      indentStep: 1
    },
    {
      title: '减:摊回赔付支出',
      dataIndex: 'AmortizationExpense',
      key: 'AmortizationExpense',
      indentStep: 1
    },
    {
      title: '提取保险责任准备金',
      dataIndex: 'PremiumReserve',
      key: 'PremiumReserve',
      indentStep: 1
    },
    {
      title: '减:摊回保险责任准备金',
      dataIndex: 'AmortizationPremiumReserve',
      key: 'AmortizationPremiumReserve',
      indentStep: 1
    },
    {
      title: '保单红利支出',
      dataIndex: 'PolicyDividendPayout',
      key: 'PolicyDividendPayout',
      indentStep: 1
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1
    },
    {
      title: '手续费及佣金支出',
      dataIndex: 'CommissionExpense',
      key: 'CommissionExpense',
      indentStep: 1
    },
    {
      title: '业务及管理费',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1
    },
    {
      title: '减:摊回分保费用',
      dataIndex: 'AmortizationReinsuranceCost',
      key: 'AmortizationReinsuranceCost',
      indentStep: 1
    },
    {
      title: '其他业务成本',
      dataIndex: 'OtherOperatingCost',
      key: 'OtherOperatingCost',
      indentStep: 1
    },
    {
      title: '资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1
    },
    {
      title: '营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit'
    },
    {
      title: '加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1
    },
    {
      title: '利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit'
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit'
    },
    {
      title: '(一)按经营持续性分类',
      dataIndex: ' ',
      key: ' '
    },
    {
      title: '持续经营净利润',
      dataIndex: 'OperSustNetP',
      key: 'OperSustNetP',
      indentStep: 1
    },
    {
      title: '(二)按所有权归属分类',
      dataIndex: ' ',
      key: ' '
    },
    {
      title: '其中:归属于母公司股东的净利润',
      dataIndex: 'NPParentCompanyOwners',
      key: 'NPParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '少数股东损益',
      dataIndex: 'MinorityProfit',
      key: 'MinorityProfit',
      indentStep: 1
    },
    {
      title: '扣除非经常性损益后的净利润',
      dataIndex: 'NetProfitCut',
      key: 'NetProfitCut',
      indentStep: 1
    },
    {
      title: '每股收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '基本每股收益',
      dataIndex: 'BasicEPS',
      key: 'BasicEPS',
      indentStep: 1
    },
    {
      title: ' 稀释每股收益',
      dataIndex: 'DilutedEPS',
      key: 'DilutedEPS',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome'
    },
    {
      title: '归属于母公司股东的其他综合收益',
      dataIndex: 'OCIParentCompanyOwners',
      key: 'OCIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的其他综合收益',
      dataIndex: 'OCIMinorityOwners',
      key: 'OCIMinorityOwners',
      indentStep: 1
    },
    {
      title: '综合收益总额',
      dataIndex: 'TotalCompositeIncome',
      key: 'TotalCompositeIncome'
    },
    {
      title: ' 归属于母公司股东的综合收益总额',
      dataIndex: 'CIParentCompanyOwners',
      key: 'CIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的综合收益总额',
      dataIndex: '归属于少数股东的综合收益总额',
      key: '归属于少数股东的综合收益总额',
      indentStep: 1
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  trust: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue'
    },
    {
      title: '利息净收入',
      dataIndex: 'NetInterestIncome',
      key: 'NetInterestIncome',
      indentStep: 1
    },
    {
      title: '其中:利息收入',
      dataIndex: 'InterestIncome',
      key: 'InterestIncome',
      indentStep: 1
    },
    {
      title: '利息支出',
      dataIndex: 'InterestExpense',
      key: 'InterestExpense',
      indentStep: 2
    },
    {
      title: ' 手续费及佣金净收入',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1
    },
    {
      title: '其中:手续费及佣金收入',
      dataIndex: 'CommissionIncome',
      key: 'CommissionIncome',
      indentStep: 1
    },
    {
      title: '手续费及佣金支出',
      dataIndex: 'CommissionExpense',
      key: 'CommissionExpense',
      indentStep: 2
    },
    {
      title: '加:投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1
    },
    {
      title: '其中:对联营企业和合营企业的投资收益/（损失）',
      dataIndex: 'InvestIncomeAssociates',
      key: 'InvestIncomeAssociates',
      indentStep: 1
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1
    },
    {
      title: '营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout'
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1
    },
    {
      title: '业务及管理费',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1
    },
    {
      title: '其他业务成本',
      dataIndex: 'OtherOperatingCost',
      key: 'OtherOperatingCost',
      indentStep: 1
    },
    {
      title: '营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit'
    },
    {
      title: '加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1
    },
    {
      title: '利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit'
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit'
    },
    {
      title: '(一)按经营持续性分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '持续经营净利润',
      dataIndex: 'OperSustNetP',
      key: 'OperSustNetP',
      indentStep: 1
    },
    {
      title: '(二)按所有权归属分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '其中:归属于母公司股东的净利润',
      dataIndex: 'NPParentCompanyOwners',
      key: 'NPParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '扣除非经常性损益后的净利润',
      dataIndex: 'NetProfitCut',
      key: 'NetProfitCut',
      indentStep: 1
    },
    {
      title: '每股收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '基本每股收益',
      dataIndex: 'BasicEPS',
      key: 'BasicEPS',
      indentStep: 1
    },
    {
      title: '稀释每股收益',
      dataIndex: 'DilutedEPS',
      key: 'DilutedEPS',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome'
    },
    {
      title: '归属于母公司股东的其他综合收益',
      dataIndex: 'OCIParentCompanyOwners',
      key: 'OCIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的其他综合收益',
      dataIndex: 'OCIMinorityOwners',
      key: 'OCIMinorityOwners',
      indentStep: 1
    },
    {
      title: '综合收益总额',
      dataIndex: 'TotalCompositeIncome',
      key: 'TotalCompositeIncome'
    },

    {
      title: '归属于母公司股东的综合收益总额',
      dataIndex: 'CIParentCompanyOwners',
      key: 'CIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '归属于少数股东的综合收益总额',
      dataIndex: 'CIMinorityOwners',
      key: 'CIMinorityOwners',
      indentStep: 1
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ],
  others: [
    {
      title: '利润表',
      dataIndex: 'time',
      key: 'time'
    },
    {
      title: '营业收入',
      dataIndex: 'OperatingRevenue',
      key: 'OperatingRevenue'
    },
    {
      title: '手续费及佣金净收入',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1
    },
    {
      title: '其中: 代理买卖证券业务净收入',
      dataIndex: 'NetProxySecuIncome',
      key: 'NetProxySecuIncome',
      indentStep: 1
    },
    {
      title: '受托客户资产管理业务净收入',
      dataIndex: 'NetTrustIncome',
      key: 'NetTrustIncome',
      indentStep: 1
    },
    {
      title: ' 手续费及佣金净收入其他项目',
      dataIndex: 'NetCommissionIncome',
      key: 'NetCommissionIncome',
      indentStep: 1
    },
    {
      title: '利息净收入',
      dataIndex: 'NetInterestIncome',
      key: 'NetInterestIncome',
      indentStep: 1
    },
    {
      title: '加:投资收益',
      dataIndex: 'InvestIncome',
      key: 'InvestIncome',
      indentStep: 1
    },
    {
      title: '其中:对联营企业和合营企业的投资收益/（损失）',
      dataIndex: 'InvestIncomeAssociates',
      key: 'InvestIncomeAssociates',
      indentStep: 1
    },
    {
      title: '公允价值变动收益',
      dataIndex: 'FairValueChangeIncome',
      key: 'FairValueChangeIncome',
      indentStep: 1
    },
    {
      title: '汇兑收益',
      dataIndex: 'ExchangeIncome',
      key: 'ExchangeIncome',
      indentStep: 1
    },
    {
      title: '其他业务收入',
      dataIndex: 'OtherOperatingRevenue',
      key: 'OtherOperatingRevenue',
      indentStep: 1
    },
    {
      title: '资产处置收益',
      dataIndex: 'AssetDealIncome',
      key: 'AssetDealIncome',
      indentStep: 1
    },
    {
      title: '其他收益',
      dataIndex: 'OtherRevenue',
      key: 'OtherRevenue',
      indentStep: 1
    },
    {
      title: '营业支出',
      dataIndex: 'OperatingPayout',
      key: 'OperatingPayout'
    },
    {
      title: '营业税金及附加',
      dataIndex: 'OperatingTaxSurcharges',
      key: 'OperatingTaxSurcharges',
      indentStep: 1
    },
    {
      title: '业务及管理费',
      dataIndex: 'OperatingAndAdminExpense',
      key: 'OperatingAndAdminExpense',
      indentStep: 1
    },
    {
      title: '资产减值损失',
      dataIndex: 'AssetImpairmentLoss',
      key: 'AssetImpairmentLoss',
      indentStep: 1
    },
    {
      title: '信用减值损失',
      dataIndex: 'CreditImpairmentL',
      key: 'CreditImpairmentL',
      indentStep: 1
    },
    {
      title: '其他业务成本',
      dataIndex: 'OtherOperatingCost',
      key: 'OtherOperatingCost',
      indentStep: 1
    },
    {
      title: '营业利润',
      dataIndex: 'OperatingProfit',
      key: 'OperatingProfit'
    },
    {
      title: '加:营业外收入',
      dataIndex: 'NonoperatingIncome',
      key: 'NonoperatingIncome',
      indentStep: 1
    },
    {
      title: '减:营业外支出',
      dataIndex: 'NonoperatingExpense',
      key: 'NonoperatingExpense',
      indentStep: 1
    },
    {
      title: '利润总额',
      dataIndex: 'TotalProfit',
      key: 'TotalProfit'
    },
    {
      title: '减:所得税',
      dataIndex: 'IncomeTaxCost',
      key: 'IncomeTaxCost',
      indentStep: 1
    },
    {
      title: '净利润',
      dataIndex: 'NetProfit',
      key: 'NetProfit'
    },
    {
      title: '(一)按经营持续性分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '持续经营净利润',
      dataIndex: 'OperSustNetP',
      key: 'OperSustNetP',
      indentStep: 1
    },
    {
      title: '(二)按所有权归属分类',
      dataIndex: '',
      key: ''
    },
    {
      title: '其中:归属于母公司股东的净利润',
      dataIndex: 'NPParentCompanyOwners',
      key: 'NPParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '扣除非经常性损益后的净利润',
      dataIndex: 'NetProfitCut',
      key: 'NetProfitCut',
      indentStep: 1
    },
    {
      title: '每股收益',
      dataIndex: '',
      key: ''
    },
    {
      title: '基本每股收益',
      dataIndex: 'BasicEPS',
      key: 'BasicEPS',
      indentStep: 1
    },
    {
      title: '稀释每股收益',
      dataIndex: 'DilutedEPS',
      key: 'DilutedEPS',
      indentStep: 1
    },
    {
      title: '其他综合收益',
      dataIndex: 'OtherCompositeIncome',
      key: 'OtherCompositeIncome'
    },
    {
      title: '归属于母公司股东的其他综合收益',
      dataIndex: 'OCIParentCompanyOwners',
      key: 'OCIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '综合收益总额',
      dataIndex: 'TotalCompositeIncome',
      key: 'TotalCompositeIncome'
    },

    {
      title: '归属于母公司股东的综合收益总额',
      dataIndex: 'CIParentCompanyOwners',
      key: 'CIParentCompanyOwners',
      indentStep: 1
    },
    {
      title: '审计意见',
      dataIndex: 'OpinionType',
      key: 'OpinionType'
    }
  ]
}

export default defineComponent({
  props: {
    itemdata: {
      type: Object,
      default: () => {
        return {}
      }
    },
    pageSourceData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: () => {
        return ''
      }
    },
    token: {
      type: String,
      default: () => {
        return ''
      }
    }
  },
  components: { Table, Nodata, DoubleRightOutlined, DoubleLeftOutlined },
  setup(props, context) {
    const myTableBlock = ref(HTMLElement)
    const scrollTable = ref(HTMLElement)
    const tooltip: any = reactive({})
    const overflow: any = reactive({})
    const pageData: any = reactive({
      data: [],
      columns: [],
      tags: [],
      activeTagVal: 1,
      classification: 'ybqy',
      noDataTitle: '',
      spinning: true,
      leftIconShow: false,
      rightIconShow: true,
      getPopupContainer: (e: HTMLElement) => e.parentNode,
      timer: null
    })
    function handleScroll() {
      if ((pageData.data || []).length === 0) return
      const position = (myTableBlock.value as any).scrollLeft
      const clientW = (scrollTable.value as any).childNodes[1].clientWidth
      const target = clientW - 769
      pageData.leftIconShow = position > 0 ? true : false
      pageData.rightIconShow = position >= target ? false : true
    }
    watch(
      () => props.pageSourceData || {},
      (val: any) => {
        switch (val.EnterpriseType) {
          case 99:
            pageData.classification = 'ybqy'
            break
          case 13:
            pageData.classification = 'bank'
            break
          case 31:
            pageData.classification = 'bond'
            break
          case 33:
            pageData.classification = 'trust'
            break
          case 35:
            pageData.classification = 'insurance'
            break
          case 39:
            pageData.classification = 'others'
            break
          default:
        }
        const data = JSON.parse(JSON.stringify(val.Profit))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          pageData.data = data
        }
        nextTick(() => {
          pageData.spinning = false
          if ((pageData.data || []).length === 0) return
          const blockEl: any = myTableBlock.value
          blockEl.scrollLeft = 0
          handleScroll()
        })
      },
      { deep: true }
    )
    pageData.noDataTitle = computed(() => {
      const res = pageData.tags.find((item: any) => {
        return item.value === pageData.activeTagVal
      })
      return res.label
    })
    pageData.tags = [
      {
        label: '按报告期',
        value: 1
      },
      {
        label: '按年度',
        value: 2
      },
      {
        label: '按单季度',
        value: 3
      },
      {
        label: '报告期同比',
        value: 4
      },
      {
        label: '年度同比',
        value: 5
      },
      {
        label: '单季度环比',
        value: 6
      }
    ]
    pageData.columns = computed(() => {
      return myColumns[pageData.classification]
    })

    async function checkTag(tag: any) {
      pageData.activeTagVal = tag.value
      pageData.data = await getDetail(pageData.activeTagVal)
      nextTick(() => {
        if ((pageData.data || []).length === 0) return
        const blockEl: any = myTableBlock.value
        blockEl.scrollLeft = 0
        handleScroll()
      })
    }
    const route = useRoute()
    function getDetail(type: number) {
      const data: any = {}
      data.data = {
        Exch: route.query.market,
        Inst: route.query.code,
        StaticsType: type,
        DataType: 2
      }
      data.headers = {
        token: props.token
      }
      return f10Api.getFinanceF10(data).then((res: any) => {
        const data = JSON.parse(JSON.stringify((res.Data || {}).Profit))
        if ((data || []).length) {
          data.forEach((item: any, i: number) => {
            item.index = 'Debt' + i
            item.time = item.EndDate ? window.moment(item.EndDate * 1000).format('YYYY-MM-DD') : '—'
          })
          // pageData.data = data
        }
        return data
      })
    }
    function scrollToTarget(direction: string) {
      const el: any = scrollTable.value
      const blockEl: any = myTableBlock.value
      const trWidth = (el.childNodes[1] as any).clientWidth // 一行的宽度
      const screenWidth = 1000 - 232 // 1屏
      const columWidth = trWidth / pageData.data.length // 1列
      const originPosition = blockEl.scrollLeft // 原始位置
      const step = screenWidth - columWidth // 每次滚动的距离=1屏-1列
      if (direction === 'left') {
        animateScroll(-step, blockEl)
        // blockEl.scrollLeft -= step
        /*  const target = 0 // 向左
        var timerLeft = setInterval(function () {
          const currentY = blockEl.scrollLeft // 当前及滑动中任意时刻位置
          const speed = Math.abs(Math.ceil((currentY - (originPosition - step)) / 2)) // 每时刻速度
          if (currentY <= originPosition - step || currentY <= target) {
            clearInterval(timerLeft)
          } else {
            // blockEl.scrollTo(currentY - speed, 0)
            blockEl.scrollLeft = currentY - speed
          }
        }, 10) */
      } else {
        // blockEl.scrollLeft += step

        animateScroll(step, blockEl)

        /** const target = trWidth - 1000 + 131 // 向右
        var timer = setInterval(function () {
          const currentY = blockEl.scrollLeft // 当前及滑动中任意时刻位置
          const speed = Math.ceil((originPosition + step - currentY) / 2) // 每时刻速度
          if (speed <= 0 || currentY >= target) {
            clearInterval(timer)
          } else {
            // blockEl.scrollTo(currentY + speed, 0)
            blockEl.scrollLeft = currentY + speed
          }
        }, 20)
        */
      }
    }
    function animateScroll(step: number, blockEl: any) {
      const target = blockEl.scrollLeft + step
      clearInterval(pageData.timer)
      pageData.timer = setInterval(() => {
        let miniStep = step / 10
        miniStep = miniStep > 0 ? Math.ceil(step) : Math.floor(step)
        if (blockEl.scrollLeft + miniStep < target) {
          blockEl.scrollLeft += miniStep
        } else {
          blockEl.scrollLeft = target
          clearInterval(pageData.timer)
          pageData.timer = null
        }
      }, 20)
    }
    function getOpinion(val: any) {
      let res
      switch (val) {
        case 1:
          res = '无保留'
          break
        case 2:
          res = '无保留带解释性说明'
          break
        case 3:
          res = '保留意见'
          break
        case 4:
          res = '拒绝/无法表示意见'
          break
        case 5:
          res = '否定意见'
          break
        case 6:
          res = '未经审计'
          break
        case 7:
          res = '保留带解释性说明'
          break
        case 10:
          res = '经审计（不确定具体意见类型）'
          break
        default:
          res = '—'
      }
      return res
    }
    let timer: any = null
    function isoverflow(e: any, key: any, t: any) {
      tooltip[key + t] = e.currentTarget.scrollWidth > e.currentTarget.clientWidth
      if (tooltip[key + t]) {
        if (!timer) {
          timer = setTimeout(() => {
            overflow[key + t] = true
          }, 400)
        }
      }
    }
    function hidetool(key: any, t: any) {
      if (timer) {
        setTimeout(() => {
          overflow[key + t] = false
          window.clearTimeout(timer)
          timer = null
        })
      }
    }
    return {
      ...toRefs(pageData),
      tooltip,
      overflow,
      isoverflow,
      hidetool,
      checkTag,
      myTableBlock,
      scrollTable,
      scrollToTarget,
      handleScroll,
      getOpinion
    }
  }
})
